import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7645a1fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "text-missing" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_4 = ["href"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: `/ico/support-blue.svg` }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "score-container" }
const _hoisted_9 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.answers, (answer) => {
    return (_openBlock(), _createElementBlock("tr", {
      title: answer.getAuditorLabel(_ctx.state.stores!)
    }, [
      (answer.toPDF() === '')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("td", null, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.Lang.getI18N("answer-missing")), 1)
            ]),
            _hoisted_3
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("td", null, [
              _createElementVNode("span", null, _toDisplayString(answer.file_urls?.length.toString()), 1)
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("span", null, [
                _createElementVNode("a", {
                  href: answer.file_urls ? answer.file_urls[0] : '0',
                  target: "_blank"
                }, _toDisplayString(_ctx.Lang.getI18N("download")), 9, _hoisted_4)
              ])
            ])
          ], 64)),
      _createElementVNode("td", null, [
        (answer.comment !== null)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "comments-container",
              onClick: ($event: any) => (_ctx.showComment(answer))
            }, _hoisted_7, 8, _hoisted_5))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("td", _hoisted_8, [
        (_ctx.question.score)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(`${answer.score}/${_ctx.question.score}`), 1))
          : _createCommentVNode("", true)
      ])
    ], 8, _hoisted_1))
  }), 256))
}